"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
exports["default"] = React.createContext({
    appSpace: '',
    appId: '',
    contentDivider: '',
    accessToken: '',
    wrapperRef: null
});
